import Api from '../../api/userApi';
export default {
  state: {
    users: [],
    user: {},
    employees: {}
  },
  mutations: {
    USER_FETCH(state, data) {
      state.users = data;
    },
    USER_FETCH_EMAIL(state, data) {
      state.user = data;
    },
    EMPLOYEES_SET(state, data) {
      state.employees = data;
    }
  },
  actions: {
    async EMPLOYEES_FETCH({commit}) {
      try {
        const response = await Api.fetchEmployees();
        commit('EMPLOYEES_SET', response.data);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    USER_FETCH(store) {
      Api.fetch().then(response => {
        store.commit('USER_FETCH', response.data);
      }).catch(error => {
        console.error(error);
      })
    },
    USER_FETCH_EMAIL(store, data) {
      Api.fetchEmail(data.email).then(response => {
        store.commit('USER_FETCH_EMAIL', response.data);

        if(data.callBack !== undefined) {
          data.callBack();
        }
      }).catch(error => {
        console.error(error);
      })
    },
    USER_CREATE(store, data) {
      //Create user
      Api.create(data.employee).then(() => {
        //Update claims
        store.dispatch('AUTH_UPDATE_CLAIMS', { email: data.employee.user.email, claims: data.services });

        //Update roles
        store.dispatch('AUTH_UPDATE_ROLES', { email: data.employee.user.email, roles: data.roles });

        store.dispatch('NOTIFY_MSG', 'user.notification.edit');
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    USER_UPDATE(store, data) {
      //Update user
      Api.update(data.employee).then(() => {
        //Update claims
        store.dispatch('AUTH_UPDATE_CLAIMS', { email: data.employee.user.email, claims: data.services });

        //Update roles
        store.dispatch('AUTH_UPDATE_ROLES', { email: data.employee.user.email, roles: data.roles });

        store.dispatch('NOTIFY_MSG', 'user.notification.edit');
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    USER_DELETE(store, data) {
      Api.delete(data).then(() => {
        store.dispatch('USER_FETCH');
        store.dispatch('NOTIFY_MSG', 'user.notification.delete');
      })
    },
    USER_CHANGE_PASSWORD(store, data) {
      Api.changePassword(data.model).then(() => {
        store.dispatch('NOTIFY_MSG', 'user.notification.changePassword');
        if(data.succeeded !== undefined)
          data.succeeded();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    USER_RESET_PASSWORD(store, data) {
      Api.forgotPassword(data).then(() => {});
    }
  }
}
